// import * as Sentry from '@sentry/node'
import axios from 'axios'
import { DisplayOption, WebshopPackage } from '../../schema/webshop-package'
import { getUrl, PRODUCTS_API_URL } from '../util/api/api'

const getProducts = (displayOptions: DisplayOption[]) =>
  axios.get<WebshopPackage[]>(getUrl(`${PRODUCTS_API_URL}?displayOptions=${displayOptions.join(',')}`)).catch(error => {
    // Sentry.captureException(error)

    throw error
  })

export default getProducts
